import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { ToastService } from '@services/toast/toast.service';
import { EventService } from '@services/event/event.service';

@Component({
  selector: 'app-technical-charging-station-unlock-modal',
  templateUrl: './technical-charging-station-unlock-modal.component.html',
  styleUrls: ['./technical-charging-station-unlock-modal.component.scss'],
})
export class TechnicalChargingStationUnlockModalComponent {
  @Input() station: ChargingStationDto;
  loadingConnectorId: number | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private chargingStationsService: ChargingStationsService,
    private toastService: ToastService,
    private eventService: EventService
  ) {}

  unlock(connectorId: number): void {
    this.loadingConnectorId = connectorId;
    this.chargingStationsService.unlockConnector(this.station.id, connectorId).subscribe({
      next: (success) => {
        this.loadingConnectorId = null;
        if (success) {
          this.toastService.success('Konnektor ' + connectorId + ' entriegelt.');
          this.eventService.sendEntityRefresh();
          this.activeModal.close();
        } else {
          this.toastService.error('Entriegeln fehlgeschlagen.');
        }
      },
      error: () => {
        this.loadingConnectorId = null;
        this.toastService.error('Entriegeln fehlgeschlagen.');
      },
    });
  }

  cancel(): void {
    this.activeModal.dismiss();
  }
}
